export default "__VITE_ASSET__CuVQRZnc__"